import * as React from 'react';
import { useGlobalState } from 'piral-core';
import { FirefliesSettings } from '../../types';

import './fireflies.css';

interface Firefly {
  id: number;
  x: number;
  y: number;
  size: number;
  duration: number;
  delay: number;
  glowIntensity: number;
  moveX1: number;
  moveY1: number;
  moveX2: number;
  moveY2: number;
  moveX3: number;
  moveY3: number;
}

export const FirefliesContainer: React.FC = () => {
  const settings = useGlobalState(x => x.firefliesSettings) as FirefliesSettings | null;
  const [fireflies, setFireflies] = React.useState<Firefly[]>([]);

  React.useEffect(() => {
    if (!settings || settings.count === 0) {
      setFireflies([]);
      return;
    }

    const newFireflies: Firefly[] = [];
    for (let i = 0; i < settings.count; i++) {
      // Gentle movement range between -80px and 80px for relaxing floating
      const randomMove = () => (Math.random() - 0.5) * 160;
      newFireflies.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: settings.minSize + Math.random() * (settings.maxSize - settings.minSize),
        duration: 15 + Math.random() * 15, // 15-30 seconds for relaxing movement
        delay: Math.random() * 10,
        glowIntensity: 0.5 + Math.random() * 0.5,
        moveX1: randomMove(),
        moveY1: randomMove(),
        moveX2: randomMove(),
        moveY2: randomMove(),
        moveX3: randomMove(),
        moveY3: randomMove(),
      });
    }
    setFireflies(newFireflies);
  }, [settings]);

  if (!settings || fireflies.length === 0) {
    return null;
  }

  return (
    <div className="neo-fireflies-container">
      {fireflies.map(firefly => (
        <div
          key={firefly.id}
          className="neo-firefly"
          style={
            {
              '--firefly-x': `${firefly.x}%`,
              '--firefly-y': `${firefly.y}%`,
              '--firefly-size': `${firefly.size}px`,
              '--firefly-duration': `${firefly.duration}s`,
              '--firefly-delay': `${firefly.delay}s`,
              '--firefly-glow': firefly.glowIntensity,
              '--firefly-color': settings.color,
              '--firefly-glow-color': settings.glowColor,
              '--firefly-move-x1': `${firefly.moveX1}px`,
              '--firefly-move-y1': `${firefly.moveY1}px`,
              '--firefly-move-x2': `${firefly.moveX2}px`,
              '--firefly-move-y2': `${firefly.moveY2}px`,
              '--firefly-move-x3': `${firefly.moveX3}px`,
              '--firefly-move-y3': `${firefly.moveY3}px`,
            } as React.CSSProperties
          }
        />
      ))}
    </div>
  );
};
